var _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffilite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73644 10.773L1.49197 10.064L1.73644 10.773ZM16.2636 7.22696L16.0191 6.51792L16.2636 7.22696ZM4.5 2.25C2.42893 2.25 0.75 3.92893 0.75 6H2.25C2.25 4.75736 3.25736 3.75 4.5 3.75V2.25ZM13.5 2.25H4.5V3.75H13.5V2.25ZM17.25 6C17.25 3.92893 15.5711 2.25 13.5 2.25V3.75C14.7426 3.75 15.75 4.75736 15.75 6H17.25ZM17.25 6.91729V6H15.75V6.91729H17.25ZM15.75 9C15.75 8.5083 16.0659 8.08844 16.508 7.936L16.0191 6.51792C14.9906 6.87254 14.25 7.84881 14.25 9H15.75ZM16.508 10.064C16.0659 9.91156 15.75 9.4917 15.75 9H14.25C14.25 10.1512 14.9906 11.1275 16.0191 11.4821L16.508 10.064ZM17.25 12V11.0827H15.75V12H17.25ZM13.5 15.75C15.5711 15.75 17.25 14.0711 17.25 12H15.75C15.75 13.2426 14.7426 14.25 13.5 14.25V15.75ZM4.5 15.75H13.5V14.25H4.5V15.75ZM0.75 12C0.75 14.0711 2.42893 15.75 4.5 15.75V14.25C3.25736 14.25 2.25 13.2426 2.25 12H0.75ZM0.75 11.0827V12H2.25V11.0827H0.75ZM1.98091 11.4821C3.00942 11.1275 3.75 10.1512 3.75 9H2.25C2.25 9.4917 1.9341 9.91156 1.49197 10.064L1.98091 11.4821ZM3.75 9C3.75 7.84881 3.00942 6.87254 1.98091 6.51792L1.49197 7.936C1.9341 8.08844 2.25 8.5083 2.25 9H3.75ZM0.75 6V6.91728H2.25V6H0.75ZM1.98091 6.51792C2.09268 6.55645 2.25 6.68463 2.25 6.91728H0.75C0.75 7.4353 1.11043 7.80444 1.49197 7.936L1.98091 6.51792ZM2.25 11.0827C2.25 11.3154 2.09268 11.4435 1.98091 11.4821L1.49197 10.064C1.11043 10.1956 0.75 10.5647 0.75 11.0827H2.25ZM16.0191 11.4821C15.9073 11.4435 15.75 11.3154 15.75 11.0827H17.25C17.25 10.5647 16.8896 10.1956 16.508 10.064L16.0191 11.4821ZM15.75 6.91729C15.75 6.68463 15.9073 6.55645 16.0191 6.51792L16.508 7.936C16.8896 7.80444 17.25 7.4353 17.25 6.91729H15.75Z",
    fill: "#726C6C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.34863,
    cy: 7.34958,
    r: 0.854861,
    transform: "rotate(45 7.34863 7.34958)",
    fill: "#726C6C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6504,
    cy: 10.6504,
    r: 0.854861,
    transform: "rotate(45 10.6504 10.6504)",
    fill: "#726C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32148 10.6785L10.6797 7.32031",
    stroke: "#726C6C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffilite);
export default __webpack_public_path__ + "static/media/affilite.2849f8ee075dad60dc7e54c8b802dec9.svg";
export { ForwardRef as ReactComponent };